import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './customLink.scss';
import classNames from 'classnames';

export const CustomLink = (props) => {
  const { to, title, className, ...rest } = props;

  return (
    <Link to={to} className={classNames('custom-link', className)} {...rest}>
      {title}
    </Link>
  );
};

CustomLink.propTypes = {
  to: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
};
